module.exports = __webpack_public_path__ + "static/media/img_difficulty@3x.83f11b90.png";